import {AccountStoreSettingDto, ErrorDtoFactory, FileDto, UserDto} from "../../dtos";
import {Dispatch} from "redux";
import {Action as AccountStoreSettingsActions} from "../actions/accountStoreSettingsActions";
import {ActionType} from "../actionTypes";
import axios from "axios";
import envManager from "../../com/envManager/EnvManager";

export const getStoreSettingForAccount = () => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        // if no userData exist
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<AccountStoreSettingsActions>) => {
        dispatch({
            type: ActionType.GET_ACCOUNT_STORE_SETTINGS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/StoreSettings/GetStoreSettings`;
            let result = await axios.get(url, config);
            let data = result.data.data
            dispatch({
                type: ActionType.GET_ACCOUNT_STORE_SETTINGS_SUCCESS,
                payload: data
            })
            dispatch({
                type: ActionType.GET_ACCOUNT_STORE_SETTINGS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.GET_ACCOUNT_STORE_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const deleteStoreSettingForAccount = (storeSettingId: number, storeSettings: AccountStoreSettingDto[]) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<AccountStoreSettingsActions>) => {
        dispatch({
            type: ActionType.DELETE_ACCOUNT_STORE_SETTINGS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/StoreSettings/${storeSettingId}`;
            let result = await axios.delete(url, config);
            const storeSettingsAfterDelete = storeSettings.filter((storeSetting) => storeSetting.id !== storeSettingId);
            dispatch({
                type: ActionType.DELETE_ACCOUNT_STORE_SETTINGS_SUCCESS,
                payload: storeSettingsAfterDelete
            })
            dispatch({
                type: ActionType.DELETE_ACCOUNT_STORE_SETTINGS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.DELETE_ACCOUNT_STORE_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const setDefaultStoreSettingForAccount = (storeSettingId: number, storeSettings: AccountStoreSettingDto[]) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);
    return async (dispatch: Dispatch<AccountStoreSettingsActions>) => {
        dispatch({
            type: ActionType.SET_DEFAULT_ACCOUNT_STORE_SETTINGS_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            const requestData = {
                defaultAccountStoreSettingId: storeSettingId
            }
            let url = `${envManager.flyerEditorServerAddress}/api/StoreSettings/SetAccountDefaultStoreSetting`;
            let result = await axios.put(url, requestData, config);
            const newStoreSettingsAfterDelete = storeSettings.map((storeSetting) => {
                return {
                    ...storeSetting,
                    isDefaultAccountStoreSetting: storeSetting.id === storeSettingId
                }
            });
            dispatch({
                type: ActionType.SET_DEFAULT_ACCOUNT_STORE_SETTINGS_SUCCESS,
                payload: newStoreSettingsAfterDelete
            })
            dispatch({
                type: ActionType.SET_DEFAULT_ACCOUNT_STORE_SETTINGS_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.SET_DEFAULT_ACCOUNT_STORE_SETTINGS_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}

export const saveStoreSettingForAccount = (storeSettingData: AccountStoreSettingDto, storeSettings: AccountStoreSettingDto[], backgroundFile: FileDto | null, logoFile: FileDto | null) => {
    let userDtoStr = localStorage.getItem('userDto');
    if(!userDtoStr){
        return async () => {}
    }
    let userDto: UserDto = JSON.parse(userDtoStr);

    // prepare files data
    const formData = new FormData();

    formData.append("Id", (storeSettingData.id ? storeSettingData.id : 0).toString());
    formData.append("AccountId", (storeSettingData.accountId ? storeSettingData.accountId : 0).toString());
    formData.append("LanguageCultureId", (storeSettingData.languageCultureId ? storeSettingData.languageCultureId : "3").toString());
    formData.append("Caption", (storeSettingData.caption ? storeSettingData.caption : 0).toString());
    formData.append("Logo", (storeSettingData.logo ? storeSettingData.logo : "").toString());
    formData.append("LogoUrl", (storeSettingData.logoUrl ? storeSettingData.logoUrl : "").toString());
    formData.append("PrimaryColorRgb", (storeSettingData.primaryColorRgb ? storeSettingData.primaryColorRgb : "").toString());
    formData.append("SecondaryColorRgb", (storeSettingData.secondaryColorRgb ? storeSettingData.secondaryColorRgb : "").toString());
    formData.append("Font", (storeSettingData.font ? storeSettingData.font : "").toString());
    formData.append("FontSizePt", (storeSettingData.fontSizePt ? storeSettingData.fontSizePt : "").toString());
    formData.append("IconContrast", (storeSettingData.iconContrast ? storeSettingData.iconContrast : 1).toString());
    formData.append("BackgroundImage", (storeSettingData.backgroundImage ? storeSettingData.backgroundImage : "").toString());
    formData.append("BackgroundImageUrl", (storeSettingData.backgroundImageUrl ? storeSettingData.backgroundImageUrl : "").toString());
    formData.append("BackgroundColorRgb", (storeSettingData.backgroundColorRgb ? storeSettingData.backgroundColorRgb : "").toString());
    formData.append("IsDefaultAccountStoreSetting", (storeSettingData.isDefaultAccountStoreSetting || false).toString());
    formData.append("StoreShelfStyleId", (storeSettingData.storeShelfStyleId ? storeSettingData.storeShelfStyleId : "").toString());

    formData.append("IsDisplayPrices", (storeSettingData.isDisplayPrices || false).toString());
    formData.append("IsDisplayPromos", (storeSettingData.isDisplayPromos || false).toString());

    if(logoFile && logoFile?.file){
        formData.append("logoImageFile", logoFile?.file!, logoFile!.label!);
    }
    if(backgroundFile && backgroundFile.file){
        formData.append("backgroundImageFile", backgroundFile?.file!, backgroundFile!.label!);
    }

    return async (dispatch: Dispatch<AccountStoreSettingsActions>) => {
        dispatch({
            type: ActionType.SAVE_ACCOUNT_STORE_SETTING_START
        })

        try {
            const config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + userDto.token
                }
            }
            let url = `${envManager.flyerEditorServerAddress}/api/StoreSettings/CreateUpdateStoreSetting`;
            let result = await axios.put(url, formData, config);
            const storeSettingsAfterDelete = storeSettings.filter((storeSetting) => storeSetting.id !== storeSettingData.id);
            const storeSettingsArrayWithNewSetting = [result.data.data, ...storeSettingsAfterDelete];
            dispatch({
                type: ActionType.SAVE_ACCOUNT_STORE_SETTING_SUCCESS,
                payload: storeSettingsArrayWithNewSetting
            })
            dispatch({
                type: ActionType.SAVE_ACCOUNT_STORE_SETTING_COMPLETE,
            })
        } catch (err) {
            dispatch({
                type: ActionType.SAVE_ACCOUNT_STORE_SETTING_ERROR,
                payload: ErrorDtoFactory.createErrorDto(err)
            })
        }
    }

}
